import {assert, assertAndContinue} from 'Asserts';
import {Cells} from 'notebook/tables/constants/RowConstants';
import TableUtil from 'notebook/tables/TableUtil';
import {formatTypedValue, formatTypedValueWithIds} from 'notebook/tables/typed-values/DataTypes';

import {getHeaderRow} from './GetPlainTextTableUtil';

interface GetPlainTextRawTableParams {
  table: Cells;
  headerRow?: Array<string>;
  rowLabels?: Array<string> | null;
  rowLabelHeader?: string | null;
  useIds?: boolean;
}
/* Given a table (a 2D array of cells containing text or typedValue), return a 2D array of strings.
 * Contrast with getPlainTextTable which uses the computedTable to determine the cell values.
 */
export default function getPlainTextRawTable({
  table,
  headerRow,
  rowLabels,
  rowLabelHeader,
  useIds,
}: GetPlainTextRawTableParams): Array<Array<string>> {
  const formatFunction = useIds ? formatTypedValueWithIds : formatTypedValue;
  if (rowLabels == null) {
    assertAndContinue(rowLabelHeader == null, `Row label header cannot be specified without row labels`, {
      rowLabels,
      rowLabelHeader,
    });
  }

  const exportedRows: Array<Array<string>> = [];
  if (headerRow) {
    exportedRows.push(getHeaderRow(headerRow, rowLabels, rowLabelHeader));
  }
  for (let i = 0; i < table.length; i++) {
    const exportedRow: Array<string> = [];
    if (rowLabels != null) {
      exportedRow.push(rowLabels[i]);
    }
    for (let j = 0; j < table[i].length; j++) {
      const cell = table[i][j];
      assert(
        !TableUtil.isCellFormula(cell),
        'getPlainTextRawTable should not be called on tables containing formulas'
      );
      const value = cell.typedValue != null ? formatFunction(cell.typedValue, cell) : cell.text;
      exportedRow.push(value);
    }
    exportedRows.push(exportedRow);
  }
  return exportedRows;
}
